var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"leader_step"},_vm._l((_vm.data),function(item,i){return _c('div',{key:i,staticClass:"item",class:_vm.classFn(item)},[_c('span',{staticClass:"my_icon"}),_c('em',[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }